import { render, staticRenderFns } from "./arrivalRecord.vue?vue&type=template&id=64c93af1&scoped=true&"
import script from "./arrivalRecord.vue?vue&type=script&lang=js&"
export * from "./arrivalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c93af1",
  null
  
)

export default component.exports